import { PolicyValidationResult } from '@policyvision/contracts';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';

import { RootLayoutContent } from '@/app/layouts/RootLayout';
import { ROUTES } from '@/app/routes/enums';
import { NavigationConfig } from '@/app/types/navigation';
import { useDownloadAttachment } from '@/attachment/hooks/useDownloadAttachment';
import { useFetchExtractedDataFromPolicy } from '@/policy/hooks/useFetchExtractedDataFromPolicy';
import { getEpicPolicyURL } from '@/policy/utils/epicUrl';

import { PolicyDetailPageBody } from './PolicyDetailPageBody';

export default function PolicyDetailPage() {
  const navigate = useNavigate();
  const { uuid } = useParams<string>();
  const policyUuid = uuid!;

  const { isLoading: isPolicyLoading, policy } =
    useFetchExtractedDataFromPolicy(policyUuid);

  const { pdfBlob, isLoading: isPdfLoading } = useDownloadAttachment(
    policy?.attachmentId,
  );

  //Task not done, this is for testing with client.
  const epicUrl = policy?.epicPolicyUuid
    ? getEpicPolicyURL(policy.epicPolicyUuid)
    : undefined;
  const navigationConfig: NavigationConfig = {
    title: policy ? `${policy.policyNumber} / ${policy.fileName}` : '',
    backAction: {
      hasBackAction: true,
      onBack: () => navigate(ROUTES.POLICY_LIST),
    },
    cta: epicUrl,
  };

  // Restore saved validations from the DB
  const initialValidations = useMemo((): PolicyValidationResult => {
    if (!policy?.validationResult) {
      return { situations: [], amendments: [], missingSections: [] };
    }
    return policy?.validationResult;
  }, [policy?.validationResult]);

  return (
    <RootLayoutContent navigationConfig={navigationConfig} noPadding>
      <PolicyDetailPageBody
        isPolicyLoading={isPolicyLoading}
        isPdfLoading={isPdfLoading}
        policy={policy}
        pdfBlob={pdfBlob}
        policyUuid={policyUuid}
        initialValidations={initialValidations}
      />
    </RootLayoutContent>
  );
}
